import { useEffect, useState } from "react";

/** ISO-8601 UTC timestamp (matches ocpp-gateway log line prefixes). */
export function formatUtcNow(now = Date.now()): string {
  return new Date(now).toISOString();
}

export function useUtcClock(intervalMs = 1000): string {
  const [utc, setUtc] = useState(() => formatUtcNow());

  useEffect(() => {
    const tick = () => setUtc(formatUtcNow());
    tick();
    const id = setInterval(tick, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return utc;
}
